<div class="arquivo-upload-table">
    <div class="table-responsive">
        <table class="table table-striped table-hover table-bordered" [id]="idTable">
            <thead>
                <tr>
                    <th class="col-options text-center" *ngIf="canEdit"></th>
                    <th class="col-tipo">Tipo</th>
                    <th class="col-nome">Arquivo</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let arquivo of arquivosUpload; let index = index">
                    <td class="col-options text-center" *ngIf="canEdit">
                        <a class="btn btn-link btn-link-delete" (click)="delete.emit(index)" title="Remover Arquivo">
                            <i class="far fa-trash-alt" aria-hidden="true"></i>
                        </a>
                    </td>
                    <td class="col-tipo" title="{{arquivo.tipoArquivo?.nome}}">
                        {{arquivo.tipoArquivo?.nome}}
                    </td>
                    <td class="col-nome" title="{{arquivo.nome}}">
                        <i [class]="arquivo.extensao | arquivoExtensaoIcon" aria-hidden="true"></i> {{arquivo.nome}}

                        <ng-template [ngIf]="arquivo.descricao">
                            <br/>
                            <small title="{{arquivo.descricao}}">
                                {{arquivo.descricao}}
                            </small>
                        </ng-template>
                    </td>
                </tr>
            </tbody>
            <tbody *ngIf="!arquivosUpload || arquivosUpload.length === 0">
                <tr>
                    <td colspan="3" class="text-center">
                        <i class="fas fa-info" aria-hidden="true"></i> Nenhum arquivo adicionado
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
